import { Folder, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateFolder(httpClient: HttpClient) {
  return (folder: Identifiable<Folder>) =>
    httpClient.sendHttpRequest<Identifiable<Folder>>({
      endpoint: `/api/folders/${folder.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        name: folder.name,
        description: folder.description,
      },
    });
}

export { updateFolder };
